<template>
  <div class="h-full">
    <BaseLayout v-if="withNavigation">
      <template #primarySection>
        <section class="flex h-full min-w-0 flex-1 flex-col overflow-y-auto">
          <SharedErrorView
            class="flex-1"
            :error="error"
            :on-click-method="handleError"
          />
        </section>
      </template>
    </BaseLayout>
    <SharedErrorView
      v-else
      :error="error"
      :on-click-method="handleError"
    />
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'
import BaseLayout from '~/components/shared/BaseLayout.vue'
import { isPersistentError, showNavigationOnErrorPage } from '~/utils/errors'

const route = useRoute()
const { status } = useAuth()

const props = defineProps({
  error: {
    type: Object as () => NuxtError,
    required: true
  }
})

// main navigation on the left, see showNavigationOnErrorPage
const withNavigation = computed(() => showNavigationOnErrorPage(props.error, status.value))

const handleError = (): Promise<void> => clearError({ redirect: '/' })

// on route change clear error. The immediate run on mount also clears the spurious
// "page not found" on first init (#626) - but not errors we raise on purpose (e.g. unknown client)
watch(() => route.fullPath, (_path, previousPath) => {
  if (previousPath === undefined && isPersistentError(props.error)) {
    return
  }
  clearError()
}, { immediate: true })
</script>
